export default __webpack_public_path__ + "static/media/gm-pt-girl.1e06a05c.webp";